import { render } from "./executionRecord.vue?vue&type=template&id=5c36c65a&scoped=true"
import script from "./executionRecord.vue?vue&type=script&lang=js"
export * from "./executionRecord.vue?vue&type=script&lang=js"

import "./executionRecord.vue?vue&type=style&index=0&id=5c36c65a&lang=scss&scoped=true"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c36c65a"]])

export default __exports__